import { model } from '../paywall/core/model'
import {Config} from '../paywall/core/config'
const idThanksWall = 'S_1';
const checkInterval = 500;

export const setUserContext = () => {
    const email = model.Usuario.getEmail();

    DD_LOGS.onReady(() => {

        const gaTimeout = setInterval(() => {
            const hasGaId = window.LN.Config.gaId
            if (hasGaId) {
                console.log(`DDLOG :: context :: email: ${email}, gaId: ${window.LN.Config.gaId}`);
                DD_LOGS.logger.setContextProperty('user.gaId', window.LN.Config.gaId);
                DD_LOGS.logger.setContextProperty('user.email', email);

                if(window.LN.Config.idWall == idThanksWall) {
                    console.log(`DDLOG :: user-loged-in-to-wall`);

                    DD_LOGS.logger.info('customEvent', { eventData: { evento: 'paywall-gracias' } });
                }

                clearInterval(gaTimeout);
            }
        }, checkInterval)
    })

    DD_RUM.onReady(() => {

        const gaTimeout = setInterval(() => {
            const hasGaId = window.hasOwnProperty('gaId')
            if (hasGaId) {
                console.log(`DDLOG :: RUM :: email: ${email}, gaId: ${window.gaid}`);
                DD_RUM.setUser({
                    gaId: window.gaId,
                    email: email
                });

                clearInterval(gaTimeout)
            }
        }, checkInterval)

    });
}

export default {
    setUserContext,
}


// WEBPACK FOOTER //
// ./Statics/scripts/common/datadog.js